module.exports = __webpack_public_path__ + "img/hcml_gallery4.02ac15bf.jpg";